"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const redux_combine_1 = require("./redux.combine");
function create(reducers, initial) {
    let state = initial;
    const reduce = (0, redux_combine_1.combine)(reducers);
    const listeners = [];
    const dispatch = (action) => {
        if (typeof action === 'function') {
            return action(dispatch, () => state);
        }
        state = reduce(state, action);
        listeners.forEach(listener => listener());
        return void 0;
    };
    const subscribe = (listener) => {
        listeners.push(listener);
        return () => {
            listeners.splice(listeners.indexOf(listener), 1);
        };
    };
    return {
        getState: () => state,
        dispatch,
        subscribe
    };
}
exports.create = create;
//# sourceMappingURL=redux.store.js.map